import { useEffect, useRef, useState } from "react";
import {
  alpha,
  Box,
  CardMedia,
  LinearProgress,
  Portal,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
// --- Imports usados SOLO por el código de REFERENCIA (lista + animaciones) ---
// Descomentar cuando la API devuelva las sugerencias para mostrarlas en la UI.
// import { useCallback, useMemo } from "react";
// import {
//   AppBar,
//   Backdrop,
//   Collapse,
//   List,
//   ListItem,
//   ListItemButton,
//   ListItemIcon,
//   ListItemText,
//   Paper,
//   Slide,
//   Toolbar,
// } from "@mui/material";
// import { EGIconButton } from "../../../../../MainComponents/Button/IconButton/IconButton";
// import { WaveBG } from "../../../../../AI/TitleAnimation/WaveBG";
// import { BoldAI, CheckIconCircle } from "../../../../../Icon";
// import { TypingText } from "../../../../../../components/AI/TypingText/TypingText";
import { EGButton } from "../../../../../MainComponents/Button/EGButton/EGButton";
import { useSnackbar } from "notistack";
import EthiquinAvatar from "../../../../../../../src/assets/images/Ethiquin/ethiquin_avatar.svg";
import EthiquinLoading from "../../../../../../../src/assets/images/Ethiquin/loadingWhite.gif";
import "./InterviewQnA.scss";
import { generateAiInterview } from "../../../../../../apis/apiAi";
import { getInterview } from "../../../../../../apis";
import { BackdropAI } from "../../../../../AI/BackdropAI/BackdropAI";
import { useReportId } from "../../../../../../context/report/ReportContext";

/* ===========================================================================
 * REFERENCIA — Catálogo simulado de preguntas.
 * Ya no se usa: `generateAiInterview` inserta las preguntas directamente en el
 * JSON de la entrevista (lado servidor). Se conserva como modelo para cuando el
 * endpoint devuelva las sugerencias y haya que enlistarlas/animarlas en la UI.
 * ===========================================================================
 */
// const suggestionQuestions = [
//   {
//     question:
//       "¿Podría describir brevemente cuál es su puesto actual y las principales funciones que desempeña dentro de la empresa?",
//     details:
//       "Identificar el rol y nivel de acceso del entrevistado a recursos financieros o administrativos, determinando su relación con las operaciones bajo investigación.",
//   },
//   {
//     question:
//       "¿Ha notado alguna irregularidad en los procesos contables, financieros o de facturación en los últimos meses?",
//     details:
//       "Detectar señales tempranas de posibles inconsistencias económicas o manipulación de registros financieros.",
//   },
//   {
//     question:
//       "¿Puede mencionar si alguna persona tenía acceso privilegiado a información o sistemas relacionados con pagos, proveedores o transferencias bancarias?",
//     details:
//       "Determinar el nivel de acceso y control de los posibles implicados sobre la información sensible o los flujos de dinero.",
//   },
//   {
//     question:
//       "¿Existen procedimientos formales de control interno y auditoría que supervisen las operaciones financieras? Si es así, ¿sabe cuándo fue la última revisión?",
//     details:
//       "Evaluar la existencia y efectividad de los mecanismos de control interno para prevenir o detectar el fraude.",
//   },
//   {
//     question:
//       "¿Ha recibido o escuchado comentarios sobre movimientos financieros inusuales, pagos duplicados o proveedores desconocidos?",
//     details:
//       "Recabar testimonios que puedan corroborar la existencia de operaciones sospechosas o comportamientos anómalos.",
//   },
//   {
//     question:
//       "¿Considera que existe alguna relación de confianza o dependencia entre los involucrados en la gestión financiera?",
//     details:
//       "Explorar vínculos personales o jerárquicos que puedan haber facilitado la comisión del fraude.",
//   },
//   {
//     question:
//       "¿Ha notado cambios recientes en el estilo de vida, comportamiento o hábitos de consumo de alguno de los empleados con acceso a fondos?",
//     details:
//       "Identificar posibles indicios externos de enriquecimiento ilícito o beneficios obtenidos por medios indebidos.",
//   },
//   {
//     question:
//       "¿Qué tipo de documentación o registros considera relevantes para revisar en esta investigación (por ejemplo, facturas, correos, contratos, reportes bancarios)?",
//     details:
//       "Orientar la búsqueda de evidencia documental útil para el análisis forense financiero.",
//   },
//   {
//     question:
//       "¿Cómo describiría el ambiente de control y ética dentro de su área o departamento?",
//     details:
//       "Evaluar la cultura organizacional en torno a la integridad, la transparencia y el cumplimiento de las normas internas.",
//   },
//   {
//     question:
//       "¿Qué medidas considera que la empresa podría implementar para prevenir futuros incidentes de fraude o malversación?",
//     details:
//       "Obtener recomendaciones del personal para fortalecer los controles internos y promover una gestión más segura de los recursos.",
//   },
// ];

export const SuggestionAI = ({
  open,
  onClose,
  // questions,    // (referencia) preguntas actuales en EditQnA
  // setQuestions, // (referencia) para insertar sugerencias en el estado local
  // interviewID,  // (referencia) se usaba para la cacheKey de localStorage
  setInterviews,
  t,
  alias,
  interviewed,
}) => {
  // ---> Custom hooks and refs <--- //
  const theme = useTheme();
  const { enqueueSnackbar } = useSnackbar();
  const id = useReportId();
  const progressIntervalRef = useRef(null);

  // ---> Estado del flujo de generación <--- //
  const [status, setStatus] = useState("idle"); // 'idle' | 'loading'
  const [progress, setProgress] = useState(0);

  // Limpia el intervalo de progreso al desmontar
  useEffect(() => {
    return () => {
      if (progressIntervalRef.current)
        clearInterval(progressIntervalRef.current);
    };
  }, []);

  // Reset al cerrar (lo invoca BackdropAI en onExited)
  const resetState = () => {
    setStatus("idle");
    setProgress(0);
    if (progressIntervalRef.current) {
      clearInterval(progressIntervalRef.current);
      progressIntervalRef.current = null;
    }
  };

  /**
   * Genera las preguntas con IA:
   * 1. Muestra el loader con barra de progreso.
   * 2. `generateAiInterview` inserta las preguntas en el JSON de la entrevista
   *    (lado servidor).
   * 3. Recarga silenciosa con `getInterview` + `setInterviews` para que las
   *    preguntas recién generadas aparezcan en EditQnA.
   * 4. Cierra este componente.
   */
  const handleGenerate = async () => {
    if (status === "loading") return;
    setStatus("loading");
    setProgress(0);

    // Progreso simulado mientras esperamos la respuesta de la API
    progressIntervalRef.current = setInterval(() => {
      setProgress((p) => Math.min(p + 10, 90));
    }, 300);

    // `interviewed.id` viene como "Nombre-Puesto" (aquí no es email)
    const fullName = interviewed?.id ?? "";
    const [name, role] = fullName.split("-");

    try {
      await generateAiInterview({
        report_id: id,
        investigation_alias: alias,
        name,
        position: role,
        type: interviewed?.from,
      });

      // Recarga silenciosa de la entrevista para reflejar las nuevas preguntas
      const interviewResp = await getInterview(alias);
      if (interviewResp?.data?.interviews) {
        setInterviews(interviewResp.data.interviews);
      }

      setProgress(100);
      enqueueSnackbar(t("Interview.questions_generated_successfully"), {
        variant: "success",
      });
      onClose();
    } catch (error) {
      console.error("Error generando preguntas con IA:", error);
      enqueueSnackbar(t("Interview.error_generating_questions"), {
        variant: "error",
      });
      setStatus("idle");
      setProgress(0);
    } finally {
      if (progressIntervalRef.current) {
        clearInterval(progressIntervalRef.current);
        progressIntervalRef.current = null;
      }
    }
  };

  return (
    <Portal>
      <BackdropAI
        open={open}
        title={t("Interview.generate_questions_with_AI")}
        onExited={resetState}
        onClose={onClose}
      >
        {status === "loading" ? (
          // ----> Loader con barra de progreso <---- //
          <Stack
            sx={{
              alignItems: "center",
              justifyContent: "center",
              minHeight: "calc(100vh - 64px)",
              flexFlow: "column",
            }}
          >
            <Box
              role="status"
              aria-live="polite"
              sx={{ width: "100%", textAlign: "center" }}
            >
              <CardMedia
                component="img"
                src={EthiquinLoading}
                alt={t("Loading Suggestions")}
                sx={{
                  width: { xs: "60%", md: "40%" },
                  height: "auto",
                  mx: "auto",
                  my: 2.5,
                  userSelect: "none",
                  pointerEvents: "none",
                }}
              />

              {/* Progress bar */}
              <Box
                sx={{
                  width: { xs: "90%", md: "70%" },
                  paddingY: 1,
                  mx: "auto",
                }}
              >
                <LinearProgress
                  variant="determinate"
                  sx={{
                    height: 8,
                    borderRadius: 4,
                    backgroundColor: "#e3f2fd",
                    "& .MuiLinearProgress-bar": {
                      borderRadius: 4,
                    },
                  }}
                  value={progress}
                  aria-label={t("Loading suggestions")}
                />
              </Box>
            </Box>
          </Stack>
        ) : (
          // ----> Pantalla inicial: avisos + botón generar <---- //
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              minHeight: "calc(100vh - 64px)",
            }}
          >
            <CardMedia
              component="img"
              src={EthiquinAvatar}
              alt={t("Finish Interview Illustration")}
              sx={{
                border: `2px solid ${theme.palette.primary.dark}`,
                borderRadius: "50%",
                width: "20%",
                height: "auto",
                mx: "auto",
                userSelect: "none",
              }}
            />

            {/* Aviso legal */}
            <Typography
              color={"warning.dark"}
              textAlign="justify"
              sx={{
                borderLeft: `5px solid ${theme.palette.warning.main}`,
                backgroundColor: alpha(theme.palette.warning.light, 0.1),
                boxShadow: `0 0 10px -4px ${theme.palette.warning.dark}`,
                borderRadius: 1,
                py: 2,
                px: 3,
                mx: 3,
                mt: 5,
                mb: 2,
                fontSize: 15,
              }}
            >
              <strong>{t("legalNotice.legal_notice")}: </strong>
              <Typography
                fontWeight={500}
                dangerouslySetInnerHTML={{
                  __html: t("legalNotice.AI_generated_questions"),
                }}
                component={"span"}
              />
            </Typography>

            {/* Aviso de sobrescritura: la generación reemplaza lo capturado */}
            <Typography
              color="error.dark"
              textAlign="justify"
              fontWeight={500}
              sx={{
                borderLeft: `5px solid ${theme.palette.error.main}`,
                backgroundColor: alpha(theme.palette.error.light, 0.1),
                boxShadow: `0 0 10px -4px ${theme.palette.error.dark}`,
                borderRadius: 1,
                py: 2,
                px: 3,
                mx: 3,
                mb: 5,
                fontSize: 15,
              }}
            >
              ⚠️ {t("Interview.AI_overwrite_warning")}
            </Typography>

            <EGButton
              label={`${t("Interview.AI")} — ${t(
                "Interview.generate_questions",
              )}`}
              color="primary"
              iconName="outline_ai"
              onClick={handleGenerate}
            />
          </Box>
        )}
      </BackdropAI>
    </Portal>
  );
};

/* ===========================================================================
 * REFERENCIA — Implementación previa basada en simulación.
 * ---------------------------------------------------------------------------
 * NO BORRAR. Este bloque NO se ejecuta; se conserva como modelo para cuando la
 * API `generateAiInterview` devuelva las sugerencias y se necesite mostrarlas
 * antes de aplicarlas. Incluye:
 *   - Caché en localStorage (TTL 24h)              -> loadFromCache/saveToCache
 *   - Animación de "typing" por sugerencia         -> TypingText + markPartComplete
 *   - Enlistado de sugerencias con Collapse        -> render de la lista
 *   - Alta individual y masiva en EditQnA          -> handleSelectSuggestion/handleAddAll
 * Para reactivarlo: descomentar también los imports y props marcados arriba.
 * ===========================================================================
 */
// // ---> Initial States <--- //
// const [suggestions, setSuggestions] = useState([]);
// const [status, setStatus] = useState("idle"); // 'idle' | 'loading' | 'done' | 'error'
// const [progress, setProgress] = useState(0);
// // Typing control: current index being typed (or null if everything is finished)
// const [typingIndex, setTypingIndex] = useState(null);
// // Control animation
// const [shouldAnimate, setShouldAnimate] = useState(false);
// const completedPartsRef = useRef({}); // { [index]: { primary: bool, secondary: bool } }
//
// // ---- CACHING HELPERS (localStorage) ----
// const cacheKey = useMemo(
//   () => `suggestion_cache_${interviewID ?? "default"}`,
//   [interviewID],
// );
// const cacheTTL = 1000 * 60 * 60 * 24; // saved 24h
//
// const loadFromCache = useCallback(() => {
//   try {
//     const raw = localStorage.getItem(cacheKey);
//     if (!raw) return null;
//     const parsed = JSON.parse(raw);
//     if (!parsed || !parsed.ts || typeof parsed.data === "undefined") {
//       localStorage.removeItem(cacheKey);
//       return null;
//     }
//     if (Date.now() - parsed.ts > cacheTTL) {
//       localStorage.removeItem(cacheKey);
//       return null;
//     }
//     return parsed; // { ts, data, ... }
//   } catch (e) {
//     console.warn("Error leyendo cache suggestions:", e);
//     return null;
//   }
// }, [cacheKey, cacheTTL]);
//
// const saveToCache = useCallback(
//   (data) => {
//     try {
//       const payload = { ts: Date.now(), data, generated: true };
//       localStorage.setItem(cacheKey, JSON.stringify(payload));
//     } catch (e) {
//       console.warn("Could not save cache suggestions:", e);
//     }
//   },
//   [cacheKey],
// );
//
// useEffect(() => {
//   if (!open) return;
//   // if there are already suggestions in status (e.g., reopen), do nothing
//   if (suggestions && suggestions.length > 0) return;
//   // Attempt to load from cache; if it exists, display everything without animation
//   const cached = loadFromCache();
//   if (cached && Array.isArray(cached.data) && cached.data.length > 0) {
//     setSuggestions(cached.data);
//     setStatus("done");
//     setProgress(100);
//     setShouldAnimate(false);
//     setTypingIndex(null);
//     return;
//   }
// }, [open, interviewID]);
//
// // When the suggestions are ready, start the animation from the first item.
// useEffect(() => {
//   if (status === "done" && suggestions.length > 0) {
//     completedPartsRef.current = {};
//     if (shouldAnimate) {
//       setTypingIndex(0);
//     } else {
//       setTypingIndex(null);
//     }
//   } else {
//     setTypingIndex(null);
//     completedPartsRef.current = {};
//   }
// }, [status, suggestions.length, shouldAnimate]);
//
// // Mark a part (primary | secondary) as complete for a given index
// const markPartComplete = useCallback(
//   (index, part) => {
//     if (!completedPartsRef.current[index]) {
//       completedPartsRef.current[index] = { primary: false, secondary: false };
//     }
//     completedPartsRef.current[index][part] = true;
//     // If there is no secondary for this item, we consider it completed immediately.
//     const hasDetails = !!(
//       suggestions[index]?.details && suggestions[index].details.trim()
//     );
//     if (!hasDetails) {
//       completedPartsRef.current[index].secondary = true;
//     }
//     const bothDone =
//       completedPartsRef.current[index].primary &&
//       completedPartsRef.current[index].secondary;
//     if (bothDone) {
//       const next = index + 1;
//       delete completedPartsRef.current[index];
//       if (next < suggestions.length) {
//         setTypingIndex(next);
//       } else {
//         setTypingIndex(null);
//       }
//     }
//   },
//   [suggestions],
// );
//
// const handlePrimaryComplete = useCallback(
//   (index) => markPartComplete(index, "primary"),
//   [markPartComplete],
// );
// const handleSecondaryComplete = useCallback(
//   (index) => markPartComplete(index, "secondary"),
//   [markPartComplete],
// );
//
// /**
//  * Ejemplo de llamada "real":
//  * - Reemplaza la función `fetchSuggestions` con tu fetch/fetchClient real.
//  * - Usamos AbortController para poder cancelar la petición si el usuario cierra.
//  */
// const fetchSuggestions = async (signal) => {
//   // === EJEMPLO SIMULADO ===
//   return new Promise((resolve, reject) => {
//     timeoutRef.current = setTimeout(() => {
//       if (signal && signal.aborted) {
//         reject(new DOMException("Aborted", "AbortError"));
//         return;
//       }
//       resolve(suggestionQuestions);
//       timeoutRef.current = null;
//     }, 2500);
//   });
// };
//
// const handleGetSuggestion = async ({ force = false } = {}) => {
//   if (status === "loading") return;
//   // Since it is an explicit generation per click -> we activate animation
//   setShouldAnimate(true);
//   setStatus("loading");
//   setProgress(0);
//   progressIntervalRef.current = setInterval(() => {
//     setProgress((p) => Math.min(p + 10, 90));
//   }, 300);
//   if (!force) {
//     const cached = loadFromCache();
//     if (cached && Array.isArray(cached.data) && cached.data.length > 0) {
//       setSuggestions(cached.data);
//       setStatus("done");
//       setProgress(100);
//       setShouldAnimate(false);
//       setTypingIndex(null);
//       return;
//     }
//   }
//   const controller = new AbortController();
//   abortControllerRef.current = controller;
//   const { signal } = controller;
//   try {
//     const data = await fetchSuggestions(signal);
//     const arr = Array.isArray(data) ? data : [];
//     setTypingIndex(-1);
//     setSuggestions(arr);
//     saveToCache(arr);
//     setStatus("done");
//     setProgress(100);
//   } catch (err) {
//     if (err.name === "AbortError") {
//       setStatus("idle");
//     } else {
//       console.error("Error fetching suggestions:", err);
//       setStatus("error");
//     }
//   } finally {
//     if (abortControllerRef.current === controller) {
//       abortControllerRef.current = null;
//     }
//     if (timeoutRef.current) {
//       clearTimeout(timeoutRef.current);
//       timeoutRef.current = null;
//     }
//   }
// };
//
// // function to normalize text (trim, multiple spaces, lowercase)
// const normalize = (str) =>
//   (str || "").trim().replace(/\s+/g, " ").toLowerCase();
//
// // Memorize a Set with the questions already present (standardized)
// const existingQuestionsSet = useMemo(() => {
//   const arr = Array.isArray(questions) ? questions : [];
//   return new Set(arr.map((q) => normalize(q?.question)));
// }, [questions]);
//
// // check if there's at least one suggestion that can be added
// const canAddAny = useMemo(() => {
//   return suggestions.some((s) => {
//     const qNorm = normalize(s?.question);
//     return qNorm && !existingQuestionsSet.has(qNorm);
//   });
// }, [suggestions, existingQuestionsSet]);
//
// const handleAddAll = useCallback(() => {
//   const toAdd = suggestions
//     .filter((s) => {
//       const qNorm = normalize(s?.question);
//       return qNorm && !existingQuestionsSet.has(qNorm);
//     })
//     .map((s) => ({
//       question: s.question ?? "",
//       details: s.details ?? "",
//       answer: "",
//       showDetails: !!(s.details && s.details.trim()),
//     }));
//   if (toAdd.length === 0) return;
//   setQuestions((prevQuestions) => {
//     if (!Array.isArray(prevQuestions) || prevQuestions.length === 0) {
//       return toAdd;
//     }
//     const lastFilledIndex = (() => {
//       for (let i = prevQuestions.length - 1; i >= 0; i--) {
//         if ((prevQuestions[i].question || "").trim() !== "") return i;
//       }
//       return -1;
//     })();
//     if (lastFilledIndex === -1) {
//       const updated = [...prevQuestions];
//       updated[0] = { ...updated[0], ...toAdd[0] };
//       if (toAdd.length > 1) updated.push(...toAdd.slice(1));
//       return updated;
//     }
//     const insertIndex = lastFilledIndex + 1;
//     const updated = [...prevQuestions];
//     updated.splice(insertIndex, 0, ...toAdd);
//     return updated;
//   });
//   enqueueSnackbar(t("Interview.all_suggestions_added"), {
//     variant: "success",
//   });
// }, [suggestions, existingQuestionsSet, setQuestions, normalize]);
//
// const handleSelectSuggestion = useCallback(
//   (suggestion, { closeOnSelect = false } = {}) => {
//     const newItem = {
//       question: suggestion?.question ?? "",
//       details: suggestion?.details ?? "",
//       answer: "",
//       showDetails: !!(suggestion?.details && suggestion.details.trim()),
//     };
//     const suggestedNorm = normalize(suggestion?.question);
//     if (existingQuestionsSet.has(suggestedNorm)) return;
//     setQuestions((prevQuestions) => {
//       if (!Array.isArray(prevQuestions) || prevQuestions.length === 0) {
//         return [newItem];
//       }
//       const lastFilledIndex = (() => {
//         for (let i = prevQuestions.length - 1; i >= 0; i--) {
//           if ((prevQuestions[i].question || "").trim() !== "") return i;
//         }
//         return -1;
//       })();
//       if (lastFilledIndex === -1) {
//         const updated = [...prevQuestions];
//         updated[0] = { ...updated[0], ...newItem };
//         return updated;
//       }
//       const insertIndex = lastFilledIndex + 1;
//       const updated = [...prevQuestions];
//       updated.splice(insertIndex, 0, newItem);
//       return updated;
//     });
//     enqueueSnackbar(t("Interview.question_added"), { variant: "success" });
//     if (closeOnSelect) onClose();
//   },
//   [existingQuestionsSet, setQuestions, onClose],
// );
//
// // ----> Render de REFERENCIA: estados loading / vacío / lista <---- //
// // {status === "loading" ? (
// //   ...loader (igual al activo de arriba)...
// // ) : suggestions.length === 0 ? (
// //   ...pantalla inicial con aviso legal + botón onClick={handleGetSuggestion}...
// // ) : (
// //   // Suggestions list
// //   <Box sx={{ px: 2 }}>
// //     {/* Button "Add all" */}
// //     {canAddAny && (
// //       <Box mt={1}>
// //         <EGButton
// //           label={t("Interview.add_all")}
// //           labelColor="white"
// //           color="success"
// //           onClick={handleAddAll}
// //           iconName="add"
// //           iconColor="white"
// //           iconColorHover="white"
// //         />
// //       </Box>
// //     )}
// //     <List>
// //       {suggestions.map((s, i) => {
// //         const suggestionQuestion = s?.question ?? "";
// //         const isAdded = existingQuestionsSet.has(
// //           normalize(suggestionQuestion),
// //         );
// //         // Visible: typingIndex === null -> todo; -1 -> nada; si no, i <= typingIndex
// //         const visible =
// //           typingIndex === null
// //             ? true
// //             : typingIndex === -1
// //               ? false
// //               : i <= typingIndex;
// //         const primaryText = `${i + 1}. ${suggestionQuestion}`;
// //         const secondaryText = s.details
// //           ? `${t("Interview.objective")}: ${s.details}`
// //           : "";
// //         return (
// //           <Collapse
// //             key={i}
// //             in={visible}
// //             timeout={180}
// //             mountOnEnter
// //             unmountOnExit
// //           >
// //             <ListItem disablePadding sx={{ mb: 0.5 }}>
// //               <ListItemButton
// //                 onClick={() => {
// //                   if (isAdded) return;
// //                   handleSelectSuggestion(s);
// //                 }}
// //                 dense
// //                 disabled={isAdded}
// //                 sx={{
// //                   border: `1px solid ${theme.palette.blueGray50.main}`,
// //                   backgroundColor: isAdded
// //                     ? alpha(theme.palette.success.main, 0.15)
// //                     : "transparent",
// //                   borderRadius: 3,
// //                   boxShadow: isAdded
// //                     ? ""
// //                     : `0 0 6px -4px ${theme.palette.common.black}`,
// //                 }}
// //               >
// //                 <ListItemIcon>
// //                   {isAdded ? (
// //                     <CheckIconCircle color={theme.palette.primary.main} />
// //                   ) : (
// //                     <EGIconButton
// //                       iconName="add_square"
// //                       iconColor="success"
// //                       iconColorHover="white"
// //                       colorHover="success"
// //                       title={t("Interview.add")}
// //                       onClick={(e) => {
// //                         e.stopPropagation();
// //                         handleSelectSuggestion(s);
// //                       }}
// //                     />
// //                   )}
// //                 </ListItemIcon>
// //                 <ListItemText
// //                   primary={
// //                     <TypingText
// //                       text={primaryText}
// //                       speed={2}
// //                       active={shouldAnimate && typingIndex === i}
// //                       onComplete={() => handlePrimaryComplete(i)}
// //                       startEmpty={shouldAnimate}
// //                     />
// //                   }
// //                   primaryTypographyProps={{
// //                     fontWeight: 600,
// //                     variant: "body1",
// //                     whiteSpace: "pre-line",
// //                   }}
// //                   secondary={
// //                     secondaryText ? (
// //                       <TypingText
// //                         text={secondaryText}
// //                         speed={2}
// //                         active={shouldAnimate && typingIndex === i}
// //                         onComplete={() => handleSecondaryComplete(i)}
// //                         startEmpty={shouldAnimate}
// //                       />
// //                     ) : null
// //                   }
// //                   secondaryTypographyProps={{
// //                     variant: "body1",
// //                     fontSize: "0.83rem",
// //                     whiteSpace: "pre-line",
// //                   }}
// //                 />
// //               </ListItemButton>
// //             </ListItem>
// //           </Collapse>
// //         );
// //       })}
// //     </List>
// //   </Box>
// // )}
